export const BREAKPOINT_MOBILE = 640;
export const BREAKPOINT_TABLET_PORTRAIT = 768;
export const BREAKPOINT_TABLET = 1024;

export const HERO_SLIDE_VH = 95;
export const DESKTOP_MARGIN = 30;